import React from "react";
import { AHText, Box, TouchableBox, useLayoutContext } from "arkh";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { Image, ImageSourcePropType } from "react-native";
import { FormattedMessage } from "react-intl";
import { OrgSpaceCreateHeightType } from "./OrgSpaceCreatePageIndexType";
import { OrgSpaceCreateTitles } from "./OrgSpaceCreateTitles";

function OrgSpaceCreateSizeOption(props: {
  source: ImageSourcePropType;
  selected?: boolean;
  height: OrgSpaceCreateHeightType;
  setHeight: (height: OrgSpaceCreateHeightType) => void;
}) {
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return (
    <TouchableBox
      style={{
        width: isCompact ? "100%" : "50%",
      }}
      space="medium"
      onPress={() => props.setHeight(props.height)}
    >
      <Box
        style={{
          flexDirection: "row",
          alignItems: "flex-start",
          borderWidth: 2,
        }}
        borderColor={props.selected ? "primary" : "surface"}
        color="surface"
        space="medium"
        cornerRadius="large"
      >
        <AHText type="title-small" spaceRight="medium">
          <FormattedMessage
            defaultMessage="Size {height} x {width}"
            description="OrgSpaceCreateSizeOption"
            values={{ height: props.height, width: 2 }}
          />
        </AHText>
        <Image
          source={props.source}
          style={{ height: 100, width: 100 * (355 / 245) }}
          resizeMode="contain"
        />
      </Box>
    </TouchableBox>
  );
}

export function OrgSpaceCreatePageSize(props: {
  height: OrgSpaceCreateHeightType;
  setHeight: (height: OrgSpaceCreateHeightType) => void;
}) {
  const layout = useLayoutContext();
  return (
    <Box spaceHorizontal="medium" style={{ flex: 1 }}>
      <OrgSpaceCreateTitles
        title={
          <FormattedMessage
            defaultMessage="Create a new Storecast Space"
            description="OrgSpaceCreatePageSize title"
          />
        }
        subTitle={
          <FormattedMessage
            defaultMessage="This represents the allocated area on the store's dashboards where you can place widgets."
            description="OrgSpaceCreatePageSize description"
          />
        }
      />
      <Box
        style={{
          width: "100%",
          marginTop: -layout.space.medium,
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        <OrgSpaceCreateSizeOption
          source={require("./StorecastSpace1x2.png")}
          setHeight={props.setHeight}
          height={1}
          selected={props.height === 1}
        />
        <OrgSpaceCreateSizeOption
          source={require("./StorecastSpace2x2.png")}
          setHeight={props.setHeight}
          height={2}
          selected={props.height === 2}
        />
        <OrgSpaceCreateSizeOption
          source={require("./StorecastSpace3x2.png")}
          setHeight={props.setHeight}
          height={3}
          selected={props.height === 3}
        />
        <OrgSpaceCreateSizeOption
          source={require("./StorecastSpace4x2.png")}
          setHeight={props.setHeight}
          height={4}
          selected={props.height === 4}
        />
      </Box>
    </Box>
  );
}
